import { getApiRegion, setApiRegion } from '../persistentStorage';

const CHINA_API_HOST = process.env.API_HOST_CN as string;
const GLOBAL_API_HOST = process.env.API_HOST as string;

export class ApiHostManager {
  private isChina: boolean = false;

  constructor() {
    const apiRegion = getApiRegion();
    if (apiRegion) {
      this.isChina = apiRegion === 'china';
    }
    this.updateRegion();
  }

  getApiHost() {
    return this.isChina ? CHINA_API_HOST : GLOBAL_API_HOST;
  }

  /** Check connectivity and update base url if needed */
  async updateRegion(): Promise<void> {
    const [hasChinaConnectivity, hasGlobalConnectivity] = await Promise.all([
      this.checkRegionConnectivityAndUpdate(CHINA_API_HOST, true),
      this.checkRegionConnectivityAndUpdate(GLOBAL_API_HOST, false),
    ]);
    if (hasChinaConnectivity && !hasGlobalConnectivity) this.setIsChina(true);
    if (hasGlobalConnectivity && !hasChinaConnectivity) this.setIsChina(false);
  }

  private async checkRegionConnectivityAndUpdate(
    apiBase: string,
    isChina: boolean,
  ): Promise<boolean> {
    const isGlobal = !isChina;
    try {
      const res = await fetch(`${apiBase}/location`).then(raw => raw.json());
      if (res && typeof res.global === 'boolean') {
        if (isGlobal === res.global) {
          this.setIsChina(isChina);
        }
        return true;
      }
    } catch (err) {
      // it's expected that this will fail when going through the firewall
      // eslint-disable-next-line no-console
      console.warn(err);
    }
    return false;
  }

  private setIsChina(isChina: boolean) {
    if (isChina !== this.isChina) {
      this.isChina = isChina;
      // persist the result so we can use this straight-away next time the page is loaded
      setApiRegion(isChina ? 'china' : 'global');
    }
  }
}
